/* eslint-disable no-undef */
export default {
    name: "dropdown",
    props: ["selectOptions", "selectedOption", "elementId", "placeholder", "disabled"],
    emits: ["changeSelect"],
    data() {
        return {
            selectElementId: "select",
            selectedValue: null,
            sizeOfOptions: "5",
            hide: false,
            options: [],
        };
    },
    methods: {
        onSelectValueChange() {
            console.log("change");
            if(this.selectedValue !== null && this.selectedValue !== ""){
                if(this.selectOptions !== null && this.selectOptions !== undefined && this.selectOptions.length > 0) {
                    var selectedText = this.selectOptions.find(option => option.id === this.selectedValue).text;
                    var selectedOption = {
                        id: this.selectedValue,
                        text: selectedText
                    };
                    this.$emit("changeSelect", selectedOption);
                }
            }
        },
        // reintialiseSelect(){
        //     var self = this;
        //     setTimeout(function () {
        //         var elementId = "#" + self.elementId;
        //         $(elementId).selectpicker("val", self.selectedValue);
        //         $(elementId).selectpicker("refresh");
        //     }, 200);
        // }
    },
    mounted: function () {

    },
    watch: {
        selectOptions: {
            handler: function () {
                //this.reintialiseSelect();
                console.log("select Options change");
                console.log("selectedOptions", this.selectOptions);
            },
            immediate: true,
            deep: true
        },
        selectedOption: {
            handler: function () {
                var self = this;
                this.selectedValue = this.selectedOption;
                console.log("selectedValue", this.selectedValue);

                // setTimeout(function () {
                //     var elementId = "#" + self.elementId;
                //     $(elementId).selectpicker("render");
                // }, 200);
            },
            immediate: true,
            deep: true
        },
        disabled:{
            handler: function () {
                //this.reintialiseSelect();
                console.log("disabled change");
            },
            immediate: true,
            deep: true
        },
        optionsSize:{
            handler: function () {
                if(this.optionsSize){
                    this.sizeOfOptions = this.optionsSize;
                }
            },
            immediate: true,
            deep: true
        }
    }
};